import * as React from 'react';
import { UpperTittleWrap, H2, H6 } from '../signInvigilatorRecords/styles';
import { StudentForm } from './studentForm';
import { PageWrapper } from './styles';
import { UnscrollableContainer } from '../../../../../misc';

export const AddStudent: React.FC = (): JSX.Element => {
  return (
    <UnscrollableContainer>
      <PageWrapper>
        <UpperTittleWrap>
          <H6>New student</H6>
          <H2>Addition</H2>
        </UpperTittleWrap>
        <StudentForm />
      </PageWrapper>
    </UnscrollableContainer>
  );
};
